import dayjs from 'dayjs'
import twemoji from 'twemoji'
import { parse as twemojiParser } from 'twemoji-parser'

export function queryParamsToObj (url = location.href) {
    const { searchParams } = new URL(url)
    const result = {}
    for (const entry of searchParams.entries()) {
        const [key, value] = entry
        result[key] = value
    }
    return result
}

export function eventPathContainsClass (event, className) {
    // e.composedPath() seems to be the standard instead of e.path
    // ofc it doesn't work in edge
    const path = event.path || event.composedPath?.()
    return path?.some($el => $el.classList?.contains(className))
}

// twemoji-parser is hardcoded to link to /v/latest.
// The twemoji.js file I downloaded uses /v/12.1.5
// Prefer /v/latest
twemoji.base = 'https://twemoji.maxcdn.com/v/latest/'

// url, text (passed in emoji)
export const twemojiToObj = emoji => twemojiParser(emoji)[0]
export const twemojiToUrl = emoji => twemojiToObj(emoji)?.url

// https://stackoverflow.com/a/42511421/2498782
export function getTwemojiImgAttribute (emojiCharacter, attr) {
    const range = document.createRange()
    const $fragment = range.createContextualFragment(emojiCharacter)
    return $fragment.firstChild.getAttribute(attr)
}

export const bttvEmoteIdToUrl = id => `https://cdn.betterttv.net/emote/${id}/1x`
export const ALIAS_ATTR = 'emote-alias'

export function bttvEmoteIdToImgTag (id, alias = id, size = 'auto') {
    const url = bttvEmoteIdToUrl(id)
    const imgStr = `<img class="emote emote-bttv" draggable="false"
        loading="lazy" alt="${alias}" ${ALIAS_ATTR}="${alias}" src="${url}"
        width="${size}" height="${size}"/>`

    return imgStr
}

export function emoteToHTML (emojiOrEmoteId, alias, size = 'auto') {
    // Setting alias='' as a default param isn't enough, it could be null.
    if (!alias) {
        alias = ''
    }

    let html = twemoji.parse(emojiOrEmoteId, {
        folder: 'svg',
        ext: '.svg',
        className: 'emote emote-twemoji',
        attributes: () => ({
            [ALIAS_ATTR]: alias,
            loading: 'lazy',
            width: `${size}`, // twemoji expects string attributes
            height: `${size}`,
        })
    })

    const didParseFail = emojiOrEmoteId === html
    if (didParseFail) {
        html = bttvEmoteIdToImgTag(emojiOrEmoteId, alias, size)
    }

    return html
}

export function gradientStringToStyleObj (gradientStr) {
    if (!gradientStr) { return {} }

    const firstColonIndex = gradientStr.indexOf(':')
    const key = gradientStr.substring(0, firstColonIndex).trim()
    let val = gradientStr.substring(firstColonIndex + 1).trim()

    val = val.replace(/\;$/, '') // strip trailing semicolon

    return { [key]: val }
}

// Try to use a format that'd be understood internationally.
// In the future, use locale specific date formats.
// TODO: I'm not happy with this current format. It's too American.
//
// arg can be anything parseable by dayjs: a string, number, date, etc.
export function defaultDateFormat (date) {
    const dateObj = dayjs(date)
    const year = dateObj.year()
    const currentYear = dayjs().year()

    let fmt = 'MMMM D'
    if (year !== currentYear) {
        fmt += ', YYYY'
    }
    return dateObj.format(fmt)
}

export function defaultDateTimeFormat (date) {
    const dateObj = dayjs(date)
    const year = dateObj.year()
    const currentYear = dayjs().year()
    // TODO: use locales?
    let fmt = 'MMMM D ,??? ?? h:mm:ss a'
    if (year !== currentYear) {
        fmt += ', YYYY, h:mm:ss a'
    }
    return dateObj.format(fmt)
}
